<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
        <div class="drawer-box" style="width:100%;height:100%">
            <section>
                <span>已选中原料：</span>
                <span style="color: #999;">{{ selectedRows.map(row => row.name).join('，') }}</span>
            </section>
            <section class="justifyBox" style="margin: 12px 0;">
                <span>LIMS检测数据</span>
                <div>
                    <span>LIMS检测数值来源：</span>
                    <a-radio-group v-model="limsSource"
                        :options="[{ label: '库存检测均值', value: 1 }, { label: '近30日检测均值', value: 2 }]"
                        @change="onLimsSourceChange" />
                </div>
            </section>

            <a-table :columns="tableColumns" :loading="tableLoading" :data-source="tableData" :row-selection="{
                selectedRowKeys,
                onChange: onSelectChange,
                getCheckboxProps,
            }" bordered :expandedRowKeys="defaultExpandedRowKeys" :pagination="false" :scroll="{ x: scrollX, y: 500 }">
            </a-table>
        </div>

        <footer>
            <div>
                <span>方程应用于所有原料：</span>
                <a-select v-model="equation" allowClear style="width: 250px" :options="equationList"
                    placeholder="请选择方程"></a-select>
            </div>
            <div>
                <a-button @click="onClose">取消</a-button>
                <a-button type="primary" @click="calAndSave">计算并保存</a-button>
            </div>
        </footer>
        <template #title>
            <b>批量应用LIMS检测</b>
        </template>

        <!-- 计算并保存进度弹窗 -->
        <a-modal :visible="progressVisible" :footer="null" :closable="false" :maskClosable="false">
            <h3><b>正在计算并保存</b></h3>
            <a-progress :percent="processPercent" :status="progressStatus" />
            <span>正在处理中，已完成{{ processPercent }}%</span>
        </a-modal>
    </a-drawer>
</template>

<script>

const tableColumns = [
    {
        title: "原料名称",
        align: 'center',
        dataIndex: "rawName",
        width: 100,
    },
    {
        title: "原料代码",
        align: 'center',
        dataIndex: "rawCode",
        width: 80,
        ellipsis: true,
    },
    {
        title: "指标",
        align: 'center',
        dataIndex: "index",
        width: 80,
        ellipsis: true,
        customRender: (text, record) => {
            return record.name + `(${record.unit})`;
        }
    }
];

const stockColumns = [
    {
        title: "库存检测均值",
        align: 'center',
        dataIndex: "stockDetectionAvgValue",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    },
    {
        title: "当前值",
        align: 'center',
        dataIndex: "nutritionAnalysisVal",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    },
    {
        title: "差异",
        align: 'center',
        dataIndex: "stockDetectionDiff",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    }
];
const last30DaysColumns = [
    {
        title: "近30日检测均值",
        align: 'center',
        dataIndex: "detection30AvgValue",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    },
    {
        title: "当前值",
        align: 'center',
        dataIndex: "nutritionAnalysisVal",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    },
    {
        title: "差异",
        align: 'center',
        dataIndex: "detection30Diff",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    }
];


export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        selectedRows: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            limsSource: 1,
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },
            drawerWidth: 1200,
            scrollX: 1140,
            tableLoading: false,
            tableColumns,
            tableData: [],

            progressVisible: false,
            processPercent: 0,
            progressStatus: 'active',

            equation: undefined,
            equationList: [], // 方程列表

            selectedRowKeys: [],
            defaultExpandedRowKeys: [],
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.calAndSaveFlag = undefined;
                this.getData();
                this.getFormulaData();
            }
        },
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1200) {
            this.drawerWidth = _width;
            this.scrollX = _width - 60;
        }
    },
    methods: {
        getCheckboxProps(record) {
            return ({
                props: {
                    disabled: record.disabled
                },
            });
        },
        onSelectChange(selectedId) {
            this.selectedRowKeys = selectedId;
        },
        processData(data) {
            this.defaultExpandedRowKeys = [];
            this.tableData = data.map(item => {
                item = { ...item.rawNutritionCalculationValueDTOList.shift(), ...item };
                item.key = item.rawId + '_' + item.nutritionId;
                this.defaultExpandedRowKeys.push(item.key);
                item.children = [];
                item.rawNutritionCalculationValueDTOList.forEach((dto) => {
                    dto.disabled = true;
                    dto.key = item.rawId + '_' + dto.nutritionId;
                    item.children.push(dto);
                });
                return item;
            });
        },
        setColumns() {
            if (this.limsSource == 1) {
                this.tableColumns = tableColumns.concat(stockColumns);
            } else {
                this.tableColumns = tableColumns.concat(last30DaysColumns);
            }
        },
        // 获取表格
        getData() {
            this.tableData = [];
            this.setColumns();
            const factoryDetail = JSON.parse(window.localStorage.getItem("factoryDetail"));
            const data = {
                factoryId: window.localStorage.getItem("factoryId"),
                orgCode: factoryDetail.ebsMaterialCode,
                rawIdList: this.selectedRows.map(row => row.rawId)
            };
            this.tableLoading = true;
            this.$post('/nhf-app/factorystaffnutritionraw/selectRawListWithLIMSCheckData', data).then(res => {
                if (res.success) {
                    this.tableData_cache = res.data;
                    this.processData(this.filterData());
                }
                this.tableLoading = false;
            });
        },
        // 过滤检测值为空的数据
        filterData() {
            const valField = this.limsSource == 1 ? 'stockDetectionAvgValue' : 'detection30AvgValue';
            const diffField = this.limsSource == 1 ? 'stockDetectionDiff' : 'detection30Diff';
            const result = [];
            this.tableData_cache.forEach(item => {
                const temp = { ...item, rawNutritionCalculationValueDTOList: [] };
                temp.rawNutritionCalculationValueDTOList = item.rawNutritionCalculationValueDTOList.filter(dto => {
                    return dto[valField] != null && dto[valField] != 0 && dto[diffField] != null && dto[diffField] != 0;
                });
                result.push(temp);
            });
            return result.filter(item => item.rawNutritionCalculationValueDTOList.length > 0);
        },
        // 获取底部选择框选项
        getFormulaData() {
            this.$http.get('/nhf-fine/equation/list').then(res => {
                let { success, data } = res;
                if (success) {
                    this.equationList = data.map(item => ({ value: item.id, label: item.name })) || [];
                    // 默认选中第一条
                    if (this.equationList.length > 0 && !this.equation) {
                        this.equation = this.equationList[0].value;
                    }
                }
            });
        },
        // LIMS检测数值来源切换
        onLimsSourceChange() {
            this.setColumns();
            this.processData(this.filterData());
        },
        async save() {
            const factoryDetail = JSON.parse(window.localStorage.getItem("factoryDetail"));
            const data = {
                equationId: this.equation,
                factoryId: window.localStorage.getItem("factoryId"),
                nutritionValueType: this.limsSource,
                orgCode: factoryDetail.ebsMaterialCode,
                rawIdList: []
            };

            this.progressVisible = true;
            const _totalCount = this.selectedRowKeys.length;
            try {
                for (let index = 0; index < _totalCount; index++) {
                    data.rawIdList.pop();
                    data.rawIdList.push(this.selectedRowKeys[index].split('_')[0]);
                    const res = await this.$post('/nhf-app/factorystaffnutritionraw/rawEquationCalculateLIMSAndBatchSave', data);
                    if (res.success) {
                        this.processPercent = Math.round((index + 1) / _totalCount * 100);
                    } else {
                        throw new Error({ data: res });
                    }
                }
                this.$success({
                    title: '数据保存成功',
                    content: '已完成多原料修改！',
                    okText: '确定',
                    onOk: () => {
                        this.calAndSaveFlag = true;
                        this.getData();
                    }
                });
            } catch (err) {
                this.$error({
                    title: '数据保存失败',
                    content: err.data.msg,
                });
            }

            this.processPercent = 0;
            this.progressVisible = false;
        },
        calAndSave() {
            if (!this.selectedRowKeys.length) {
                this.$message.warning("请先选择原料");
            } else {
                const _this = this;
                _this.$confirm({
                    title: '计算并保存结果',
                    content: '我们将根据您选择的【LIMS检测数值类型】批量计算并保存到原料中，你还要继续吗?',
                    okText: '确定',
                    cancelText: '取消',
                    onOk() {
                        _this.save();
                    },
                });
            }
        },
        onClose() {
            this.limsSource = 1;
            this.equation = undefined;
            this.selectedRowKeys = [];
            this.$emit('close', this.calAndSaveFlag);
        },
    }
};
</script>


<style lang="scss" scoped>
.containers {
    width: 100%;
    flex: 1;
    height: calc(100vh - 100px);
}

::v-deep .drawer {
    overflow: hidden;

    .ant-drawer-wrapper-body,
    .ant-drawer-wrapper-body {
        overflow: hidden;
    }
}

::v-deep .ant-checkbox-wrapper-disabled {
    display: none;
}

::v-deep .ant-table-row-expand-icon {
    display: none;
}

footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    border-top: 1px solid #e9e9e9;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ant-btn {
        margin-right: 20px;
        min-width: 60px;
    }

    >div {
        display: flex;
        align-items: center;
    }
}
</style>
